import { TableHead as MuiTableHead, type TableHeadProps as MuiTableHeadProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { TableRowHoverContext } from '../TableRow/TableRowHoverContext';

type Props = WithoutStyleOverrides<MuiTableHeadProps>;

export function TableHead(props: Props) {
  return (
    <TableRowHoverContext.Provider value={false}>
      <MuiTableHead {...props} />
    </TableRowHoverContext.Provider>
  );
}

export type { Props as TableHeadProps };
